"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ScreenSize_1 = __importDefault(require("@web/common/ScreenSize"));
const ScrollingState_1 = __importDefault(require("@web/common/ScrollingState"));
const Tooltip_1 = __importDefault(require("@web/common/Tooltip"));
(() => {
    const header = document.getElementById('header');
    const openMenuInput = document.getElementById('open-menu');
    let isMenuOpen = false;
    if (header === null || openMenuInput === null) {
        return;
    }
    const tooltipElements = Array.from(header.querySelectorAll('.tooltip'));
    tooltipElements.forEach((tooltipElement) => {
        var _a;
        const count = Number((_a = tooltipElement.querySelector('.items-count')) === null || _a === void 0 ? void 0 : _a.textContent);
        const tooltip = new Tooltip_1.default(tooltipElement, false);
        if (count === 0) {
            tooltip.create();
        }
        tooltipElement.addEventListener('updateTooltipEvent', (event) => {
            const isCountZero = (event).detail.count === 0;
            if (isCountZero) {
                tooltip.create();
            }
            else {
                tooltip.destroy();
            }
        });
    });
    openMenuInput.addEventListener('change', () => {
        isMenuOpen = openMenuInput.checked;
        if (isMenuOpen === true) {
            ScrollingState_1.default.disableScrolling();
        }
        else {
            ScrollingState_1.default.enableScrolling();
        }
    });
    window.addEventListener('resize', () => {
        if (isMenuOpen === true && ScreenSize_1.default.isSmallScreen() === false) {
            ScrollingState_1.default.enableScrolling();
            openMenuInput.checked = false;
        }
    });
    document.addEventListener('click', (event) => {
        const customerMenu = document.getElementById('user-menu-dropdown-label-container');
        const userMenuCheckbox = document.getElementById('user-menu');
        if (customerMenu && userMenuCheckbox) {
            const isTouchOutsideCustomerMenu = customerMenu !== event.target
                && customerMenu.contains(event.target) === false
                && userMenuCheckbox !== event.target;
            if (isTouchOutsideCustomerMenu && userMenuCheckbox.checked) {
                userMenuCheckbox.checked = false;
            }
        }
    });
})();
